import { useMemo } from 'react';
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import EncartContact from '../../components/encart-contact';
import style from './block.module.scss';
import clsx from 'clsx';
import ClubLabels from './clubs-labels';
import { getRegisterLink } from '../../shared/tools';
import { toStructureLogoSrc } from '../../utils/functions';
import { StructureLogoOrGeneric } from '../../components/StructureLogoOrGeneric/StructureLogoOrGeneric';

const HomeHeroClub = ({ post, backgroundHeader, labels }) => {
    const link = getRegisterLink(post);

    const namePostType = useMemo(() => {
        if (post.post_type === 'smartfire-comites') return 'le comité';
        if (post.post_type === 'smartfire-ligues') return 'la ligue';
        return 'le club';
    }, [post]);

    const listFiltered =
        labels && Object.entries(labels).filter(([key, value]) => value === true);
    const hasLabels = listFiltered && listFiltered.length > 0;

    const blockClasses = clsx({
        [style.block]: true,
        [style.comite]: post.post_type === 'smartfire-comites',
        [style.ligue]: post.post_type === 'smartfire-ligues',
    });

    const benevolatMailTo =
        'mailto:' +
        post.acf.email_club +
        '?subject=Demande de bénévolat via le site Mon Club&body=Bonjour,%0D%0DJe souhaite devenir bénévole au sein de votre du club ' +
        post.post_title +
        '. Je peux apporter mon expérience et compétences dans les missions suivantes :%0D%0D- [Merci de renseigner une mission souhaitée]%0D- [Merci de renseigner une mission souhaitée]%0D- [Merci de renseigner une mission souhaitée]%0D%0DVous pouvez me recontacter au [Merci de renseigner votre numéro de téléphone] ou par mail [Merci de renseigner votre adresse mail].%0DDans l’attente de votre retour,%0D%0DCordialement,%0D%0D';

    return (
        <BlockWrapper.Div className={style.homeHeroContainer}>
            <div
                className={blockClasses}
                style={{
                    backgroundImage: backgroundHeader
                        ? 'url(' + backgroundHeader + ')'
                        : null,
                }}
            >
                <div className={style.container}>
                    <div className={style.logos}>
                        <StructureLogoOrGeneric
                            className={style.structure}
                            imageUrl={toStructureLogoSrc(post['acf']['logo_club'], 128)}
                            title="Logo du club"
                        />
                    </div>
                    <h1 className={style.title}>{post.post_title}</h1>

                    <div className={style.contactButtons}>
                        <a
                            href={link}
                            target={'_blank'}
                            rel={'noreferrer'}
                            className={style.contact}
                        >
                            ✉️ Contacter {namePostType}
                        </a>

                        {post.acf.email_club && (
                            <a
                                href={benevolatMailTo}
                                target={'_blank'}
                                rel={'noopener noreferrer'}
                                title="Devenir bénévole"
                                className={style.benevolat}
                            >
                                ✉️ Devenir bénévole dans ce club
                            </a>
                        )}
                    </div>
                </div>
            </div>
            <div className={style.clubInfosContainer}>
                <div className={style.triangle} />
                <div className={style.clubInfos}>
                    <EncartContact post={post} hasLabels={hasLabels} />
                    {hasLabels && <ClubLabels listFiltered={listFiltered} />}
                </div>
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: HomeHeroClub,
});
